// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
// RxJS
import { Observable, throwError } from 'rxjs';
import { tap, catchError, retry, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { SignalRService } from '../../../../mbs/services/signalR/signal-r.service';
// import { debug } from 'util';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
    /**
     *
     */
    constructor(private toastrService: ToastrService, private signalRService: SignalRService) {}
    // intercept request and add token
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // tslint:disable-next-line:no-debugger
        // modify request
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${localStorage.getItem(environment.authTokenKey)}`,
            },
        });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (
                        event.body &&
                        event.body.success &&
                        !event.body.data &&
                        event.body.message &&
                        event.body.message.length > 0
                    ) {
                        this.toastrService.success(event.body.message);
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                let errorMessage = 'Bilinmeyen bir hata oluştu';

                if (error.status === 401 && localStorage.getItem(environment.authTokenKey)) {
                    localStorage.removeItem(environment.authTokenKey);
                    this.signalRService.stopConnection().then(() => {
                        console.log('Connection stoppped!');
                    });
                    location.reload();
                }
                if (error.status === 403) {
                    errorMessage = 'Bu işlemi gerçekleştirmek için yetkiniz bulunmuyor.';
                    this.toastrService.warning('Bu işlemi gerçekleştirmek için yetkiniz bulunmuyor.', 'Yetki Hatası!');
                }
                if (error.status === 400) {
                    if (!error.error.success && error.error.message && error.error.message.length > 0) {
                        this.toastrService.error(error.error.message, 'Hata!');
                    }
                }
                if (error.status === 422) {
                    this.toastrService.warning(
                        'İşlemin tamamlanması için alanları doğru ve eksiksiz olarak girmelisiniz.',
                        'Doğrulama Hatası!'
                    );
                }
                if (error.status === 500) {
                    this.toastrService.error(error.error.message, 'Hata!');
                }
                return throwError(error);
            })
        );
    }
}
